import ThemeProviderCustomization from './customizationTheme/ThemeProviderCustomization';
import Main from './Main';
import Layout from './Layout/Layout';
import { UserBusinessCard, UserSettings } from './people';
import Video from './video';
import VideoNotifications from './notifications/videoNotifications';
import VenueRoutes from './VenueRoutes';
import { useEventDetailsContext } from './contexts/RingContext';
import { StylesProvider } from '@material-ui/core/styles';

const createGenerateId = (rule, sheet) => {
    return `${sheet.options.classNamePrefix}-${rule.key}`;
};

const Ring = () => {
    const { eventUniqueName } = useEventDetailsContext();
    return (
        <StylesProvider generateClassName={createGenerateId}>
            <ThemeProviderCustomization eventUniqueName={eventUniqueName}>
                <Main eventUniqueName={eventUniqueName}>
                    <Layout eventUniqueName={eventUniqueName}>
                        <VenueRoutes eventUniqueName={eventUniqueName} />
                        <UserBusinessCard eventUniqueName={eventUniqueName} />
                    </Layout>
                    <Video eventUniqueName={eventUniqueName} />
                    <VideoNotifications eventUniqueName={eventUniqueName} />
                    <UserSettings eventUniqueName={eventUniqueName} />
                </Main>
            </ThemeProviderCustomization>
        </StylesProvider>
    );
};

export default Ring;
